export var STORAGE_KEY = 'auth-widget/remembered_accounts';